export function transformToBackendGetAlertcasesByEvent(data: any) { // eslint-disable-line
  return {
    event_type_id: data.event_type_id,
    event_id: data.event_id,
  };
}

export function transformFromBackendGetAlertcasesByEvent(backendType: any) { // eslint-disable-line
  return backendType;
}

